import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Link } from '@calendly/ui/components/link';
import { LabelText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { isAdminOrOwnerSelector } from 'selectors/current_user';
import { Option } from './option';
const infoCss = "i56do1p";
const Info = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(infoCss, props.className)} />;
});
const infoTextCss = "iwmu9e4";
const InfoText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(infoTextCss, props.className)} />;
});
const optionsCss = "o1brq573";
const Options = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(optionsCss, props.className)} />;
});
const NewInvitationLink = ({
  children
}) => <Link href="/app/admin/invitations/new" target="_blank" rel="opener">{children}</Link>;
export const SearchContent = ({
  isMultiSelect,
  onSelect,
  searching,
  suggestions,
  allSuggestions
}) => {
  const isAdminOrOwner = useSelector(isAdminOrOwnerSelector);
  const notFoundPlaceholderText = isAdminOrOwner ? HtmlParser(I18n.t('publisher.organization.user_groups.management.assign_admins.not_found_description_admin'), {
    NewInvitationLink
  }) : I18n.t('publisher.organization.user_groups.management.assign_admins.not_found_description');
  if (searching || !suggestions || allSuggestions.length === 0) {
    return <Info>
        <InfoText>
          {I18n.t('publisher.organization.memberships_picker.searching')}
        </InfoText>
      </Info>;
  }
  if (suggestions?.length === 0) {
    return <Info>
        <LabelText size="medium">
          {I18n.t('publisher.organization.memberships_picker.not_found')}
        </LabelText>
        <InfoText>{notFoundPlaceholderText}</InfoText>
      </Info>;
  }
  return <Options role="listbox" aria-label={I18n.t('publisher.action.options')}>
      {suggestions.map(suggestion => {
      const optionProps = allSuggestions.find(({
        id
      }) => suggestion.id === id);
      return <Option key={suggestion.id} suggestion={suggestion} selected={optionProps?.selected} disabled={optionProps?.disabled} disabledHint={optionProps?.disabledHint} onSelect={onSelect} isMultiSelect={isMultiSelect} />;
    })}
    </Options>;
};

require("./search_content.wyw-in-js.css!=!../../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./search_content.js");